import React from 'react'
import Skeleton from '../Skeleton'

const DashboardSkeleton = () => {
    return (
        <div className="p-4 sm:p-6 max-w-7xl mx-auto">
            {/* Header */}
            <div className="flex items-center justify-between mb-6">
                <div>
                    <Skeleton className="h-8 w-64 mb-2" />
                    <Skeleton className="h-4 w-48" />
                </div>

                <Skeleton className="h-10 w-28 rounded-lg" />
            </div>

            {/* Analytics Section Skeleton */}
            <div className="mb-8">
                <div className="flex items-center justify-between mb-6">
                    <Skeleton className="h-7 w-48" />
                    <div className="flex space-x-2">
                        <Skeleton className="h-8 w-20 rounded-lg" />
                        <Skeleton className="h-8 w-20 rounded-lg" />
                        <Skeleton className="h-8 w-20 rounded-lg" />
                    </div>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
                    <Skeleton className="h-[350px] rounded-xl bg-white/5" />
                    <Skeleton className="h-[350px] rounded-xl bg-white/5" />
                </div>
            </div>

            {/* Summary Cards */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
                {[1, 2, 3, 4].map((i) => (
                    <div key={i} className="glass-card p-6">
                        <div className="flex items-center justify-between">
                            <div>
                                <Skeleton className="h-4 w-24 mb-2" />
                                <Skeleton className="h-8 w-32" />
                            </div>
                            <Skeleton className="h-12 w-12 rounded-full" />
                        </div>
                    </div>
                ))}
            </div>

            {/* Quick Payment Section */}
            <div className="glass-card p-6 mb-8">
                <Skeleton className="h-7 w-40 mb-6" />

                <div className="space-y-4">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div className="space-y-2">
                            <Skeleton className="h-4 w-20" />
                            <Skeleton className="h-10 w-full rounded-lg" />
                        </div>
                        <div className="space-y-2">
                            <Skeleton className="h-4 w-20" />
                            <Skeleton className="h-10 w-full rounded-lg" />
                        </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div className="space-y-2">
                            <Skeleton className="h-4 w-32" />
                            <div className="flex space-x-2">
                                <Skeleton className="h-10 flex-1 rounded-lg" />
                                <Skeleton className="h-10 w-12 rounded-lg" />
                            </div>
                        </div>
                        <div className="space-y-2">
                            <Skeleton className="h-4 w-32" />
                            <Skeleton className="h-10 w-full rounded-lg" />
                        </div>
                    </div>

                    <Skeleton className="h-10 w-32 rounded-lg mt-4" />
                </div>
            </div>
        </div>
    )
}

export default DashboardSkeleton
